const state = {

    Schedules : []
    
  }
  
  const mutations = {
    SetSchedules(state, payload){
        state.Schedules = payload
    },
    SetIndividualSchedules(state, payload){
        state.Schedules.push(payload)
    },
    UpdateIndividualSchedules(state, payload){

        let index = state['Schedules'].findIndex(x => x["_id"] == payload["_id"])
        state['Schedules'].splice(index,1,payload)
    },
    DeleteIndividualSchedules(state, payload){

        let index = state['Schedules'].findIndex(x => x["_id"] == payload["_id"])
        state['Schedules'].splice(index,1)
    }

  }
  
  const actions = {
    
  }
  
  const getters = {

    GetSchedules(state){

        return state.Schedules
      }
  }
  
  export default {
    state,
    mutations,
    actions,
    getters
  }
  